export default "__VITE_ASSET__Czjs_3aa__"